// extracted by mini-css-extract-plugin
export default {"OptionsForm":"OptionsForm_OptionsForm__BIj4g","input":"OptionsForm_input__AJG5f","button":"OptionsForm_button__LW5hk"};